import React from 'react';
import { TriggerProps, useFaContent, useInitiateMatchTriggers } from 'src/feature-app';
import { ProspectsCalculadoraEmbedded, ProspectsMatchEmbedded } from 'src/forms';
import { ProspectsActionTrigger } from './ProspectsActionTrigger';

export function ProspectsEmbeddedTrigger({ setSelectedJourney }: TriggerProps): JSX.Element {
	const { featureApp } = useFaContent();
	if (featureApp === 'es-match') {
		useInitiateMatchTriggers(setSelectedJourney, <ProspectsMatchEmbedded />);
	} else if (featureApp === 'es-calculadora') {
		return <ProspectsCalculadoraEmbedded setSelectedJourney={setSelectedJourney} />;
	} else if (featureApp === 'action') {
		return <ProspectsActionTrigger setSelectedJourney={setSelectedJourney} />;
	}

	return null;
}
